
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ApiLoder = () => {
  return (
    <>
      <div className="spinner_overlay"></div>
      <div className="spinner-box">
        <img
          src="/image/loder.gif"
          alt=""
          className="loading-icon"
          loading="lazy"
        />
      </div>
    </>
  );
};

const Loader = () => {
  return (
   <div className="job-loader-card mb-3">
      <div className="skeleton skeleton-title mb-2"></div>
      <div className="skeleton skeleton-subtitle mb-2"></div>
      <div className="skeleton skeleton-line w-75 mb-2"></div>
      <div className="skeleton skeleton-line w-50"></div>
    </div>
  );
};

const NoRecord = () => {
  return (
  <div className="no-record-card text-center py-5">
    
      <h4 className="mt-3">No Service Found</h4>
      <p className="text-muted">Try adjusting your filters.</p>
    </div>
  );
};

const removeAuth = () =>{
    localStorage.removeItem('userData')
    localStorage.removeItem('accessToken');
    
  }

const ToastContent = ({ title, type }) => (
  <div className="d-flex align-items-center gap-2">
    <span className={`toast-icon ${type}`}>
      {type === "success" ? "✓" : "✕"}
    </span>
    <span className="toast-text">{title}</span>
  </div>
);

const SuccessMessage = (message) => {
  toast.success(<ToastContent title={message} type="success" />, {
    position: "top-center",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    icon: false,
    className: "kebab-toast kebab-toast-success",
    progressClassName: "kebab-toast-progress-success",
  });
};

const ErrorMessage = (message) => {
  toast.error(<ToastContent title={message} type="error" />, {
    position: "top-center",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    icon: false,
    className: "kebab-toast kebab-toast-error",
    progressClassName: "kebab-toast-progress-error",
  });
};


export {
  ApiLoder,removeAuth,SuccessMessage,ErrorMessage,Loader,NoRecord
};